<template>
    <div>
        支付成功
        <div @click="backEvent">返回</div>
    </div>
</template>
<script lang="ts" setup>
import { getUserInfo } from "@/api/common.js"
import { useStore } from "vuex"
import { useRouter } from 'vue-router';
const store = useStore();
const router = useRouter()
function backEvent() {
    getUser(() => {
        router.go(-1)
    })
}

function getUser(cb) {
    getUserInfo().then(res => {
        store.dispatch('setLogin', res.data);
        cb && cb()
    })
}
</script>
